import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent, UserService, BaseDataService, BaseCommonComponent, ModalService, ModelDataService, QueryParameter, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
//import { formGroupNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';
import { FormGroup, FormControl, Validators } from '@angular/forms';
//import { formControlBinding } from '@angular/forms/src/directives/ng_model';
import { PrometRobeZaKomitentaPoArtiklima } from './promet-robe-za-komitenta-po-artiklima';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { KarticaMpArtikla } from '../kartica-mp-artikla/kartica-mp-artikla';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-promet-robe-za-komitenta-po-artiklima',
  templateUrl: './promet-robe-za-komitenta-po-artiklima.component.html'
})
export class PrometRobeZaKomitentaPoArtiklimaComponent
  extends BaseCommonComponent
  implements OnInit {
  Config = {}
  mainItems = []

  baseFormGroup: FormGroup = new FormGroup({
    // DatumOd:new FormControl()
    // , DatumDo:new FormControl()
    // , KomitentID:new FormControl()
    // , VrstaIzvestajaSinteticki:new FormControl('true')
    // , VrstaIzvestajaSintetickiRpt:new FormControl('true')
  })

  get fc() { return this.baseFormGroup.controls; }
  submitted: boolean = false;
  ID: number;
  podaciSuUcitani: boolean = false;

  constructor(

    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    protected modelDataService: ModelDataService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService
    protected toastrService: NotificationService
  ) {

    super(activatedRoute, userService, baseDataService, translateService, modalService, toastrService);
  }

  ngOnInit() {
    super.ngOnInit();
    // this.addValidatorToFc("DatumOd", Validators.required, 'required', 'PROMETROBEZAKOMITENTAPOARTIKLIMA.DATUMOD.VALIDATION.REQUIRED');
    // this.addValidatorToFc("DatumDo", Validators.required, 'required', 'PROMETROBEZAKOMITENTAPOARTIKLIMA.DATUMDO.VALIDATION.REQUIRED');
    // this.addValidatorToFc("KomitentID", Validators.required, 'required', 'PROMETROBEZAKOMITENTAPOARTIKLIMA.KOMITENTID.VALIDATION.REQUIRED');
    // this.addValidatorToFc("VrstaIzvestajaSinteticki", Validators.required, 'required', 'PROMETROBEZAKOMITENTAPOARTIKLIMA.KOMITENTID.VALIDATION.REQUIRED');
    let dateNow = new Date();
    this.baseFormGroup = new FormGroup({
      DatumOd: new FormControl(new NgbDate(dateNow.getFullYear(), 1, 1), [Validators.required]),
      DatumDo: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate()), [Validators.required]),
      KomitentID: new FormControl(null, [Validators.required]),
      VrstaIzvestajaSinteticki: new FormControl("true", [Validators.required]),
      VrstaIzvestajaSintetickiRpt: new FormControl("true", [Validators.required])
    })

  }

  OnModelDataLoaded() {
    super.OnModelDataLoaded();
    this.Config = {
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      Height: '100w',
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: false
      }
      , BreadCrumble: this.modelData.BreadcrumbLabel
    }

  }

  TableItemSelected(item) {
    // alert(item.RobaId);

    let _modelData = this.modelDataService.GetModelDataByPath("kartica-mp-artikla-modal");

    let qpDatumOd = new QueryParameter("DatumOd", this.baseFormGroup.get("DatumOd").value);
    let qpDatumDo = new QueryParameter("DatumDo", this.baseFormGroup.get("DatumDo").value);
    let qpKomitentID = new QueryParameter("KomitentID", this.baseFormGroup.get("KomitentID").value);
    let qpRobaID = new QueryParameter("RobaID", item.RobaId);

    this.modalService.ShowModal(0, _modelData, null, false, [qpDatumOd, qpDatumDo, qpKomitentID, qpRobaID])
      .result
      .then((item) => {
        //OK
      }, (reason) => {
        //!OK
      })
    // })
  }

  LoadUkupno() {
    let _modelData = this.modelDataService.GetModelDataByPath("promet-robe-za-komitenta-po-artiklima-ukupno");

    let qpDatumOd = new QueryParameter("DatumOd", this.baseFormGroup.get("DatumOd").value);
    let qpDatumDo = new QueryParameter("DatumDo", this.baseFormGroup.get("DatumDo").value);
    let qpKomitentID = new QueryParameter("KomitentID", this.baseFormGroup.get("KomitentID").value);

    this.modalService.ShowModal(0, _modelData, null, false, [qpDatumOd, qpDatumDo, qpKomitentID])
      .result
      .then((item) => {
        //OK
      }, (reason) => {
        //!OK
      })

  }

  MenjajUslove() {
    this.baseFormGroup.get("DatumOd").enable()
    this.baseFormGroup.get("DatumDo").enable();
    this.baseFormGroup.get("KomitentID").enable();
    this.podaciSuUcitani = false;
  }

  OnDataLoaded() {
    super.OnDataLoaded();

    this.podaciSuUcitani = true;
    this.baseFormGroup.get("DatumOd").disable();
    this.baseFormGroup.get("DatumDo").disable();
    this.baseFormGroup.get("KomitentID").disable();
  }

  LoadSumForm() {

    let _modelData = this.modelDataService.GetModelDataByPath("promet-robe-za-komitenta-po-artiklima-ukupno");

    let total = this.items.get(this.items.count() - 1);

    let qpT01VrednostUlazaPoNabavnojCeni
      = new QueryParameter("T01VrednostUlazaPoNabavnojCeni", total["T01VrednostUlazaPoNabavnojCeni"]);
    let qpT02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni
      = new QueryParameter("T02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni", total["T02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni"]);
    let qpT03VrednostIzlazaArtikalaPoProdajnojCeni
      = new QueryParameter("T03VrednostIzlazaArtikalaPoProdajnojCeni", total["T03VrednostIzlazaArtikalaPoProdajnojCeni"]);
    let qpT04UkupnoPdvIzlazRobe
      = new QueryParameter("T04UkupnoPdvIzlazRobe", total["T04UkupnoPdvIzlazRobe"]);
    let qpT05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv
      = new QueryParameter("T05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv", total["T05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv"]);
    let qpT06RealizacijaDoUlozenogNovca
      = new QueryParameter("T06RealizacijaDoUlozenogNovca", total["T06RealizacijaDoUlozenogNovca"]);
    let qpT07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda
      = new QueryParameter("T07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda", total["T07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda"]);

    this.modalService.ShowModal(0, _modelData, null, false, [
      qpT01VrednostUlazaPoNabavnojCeni
      , qpT02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni
      , qpT03VrednostIzlazaArtikalaPoProdajnojCeni
      , qpT04UkupnoPdvIzlazRobe
      , qpT05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv
      , qpT06RealizacijaDoUlozenogNovca
      , qpT07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda
    ])
      .result
      .then((item) => {
        //OK
      }, (reason) => {
        //!OK
      }
      )

  }
}
